import React, { useEffect, useState } from 'react'
import { getProjectList } from '../../ProjectManagement/Service/TaskService';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function MyProjects() {
    const [projectDetails, setProjectDetails] = useState({ ProjectSummary: {}, ProjectList: [] });
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      GetProjects();
    }, []);

    async function GetProjects() {
      setLoading(true);
      let body = {
        Id: 0,
        StartDate: "",
        EndDate: "",
        ProjectStatusId: "",
        PageNumber: 1,
        PageSize: 1000,
        Search: "",
        ProjectTypeId: "",
        ClientId: "",
        SortBy: "Last Used",
        SortOrder: "Desc",
      };
  
      try {
        let res = await getProjectList(body);
        const response = res?.Data || { ProjectSummary: {}, ProjectList: [] };
        setProjectDetails(response);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  
  return (
    <>
      {loading ? (
        <div className="og-card-box">
          <div className="ch">
            <Skeleton width={160} height={18} />
            <Skeleton width={30} height={18} style={{ marginLeft: 'auto' }} />
          </div>
          <div className="cb-box">
            {[1, 2, 3].map((i) => (
              <div key={i} className="proj-row">
                <Skeleton circle width={10} height={10} />
                <Skeleton width={140} height={13} style={{ marginLeft: 8 }} />
                <Skeleton width={55} height={13} style={{ marginLeft: 'auto' }} />
              </div>
            ))}
          </div>
          <div className="card-footer-bx">
            <Skeleton width={120} height={13} />
          </div>
        </div>
      ) : (
        <div className="og-card-box">
          <div className="ch-box">
            <i className="ch-icon fa-solid fa-folder-open"></i>
            <h5>Recent projects</h5>
            <span className="sprints-badge sprints-gray">{projectDetails?.ProjectList?.slice(0, 3)?.length ?? 0}</span>
          </div>
          <div className="cb-box">
            {projectDetails?.ProjectList?.slice(0, 3).map((project, index) => {
              const name = project?.ProjectName || project?.Name || project?.ProjectCode || 'Untitled project';
              const tasks = project?.TaskCount ?? 0;
              const status = project?.ProjectStatus || 'Unknown';
              const dotClasses = ['bg-danger', 'bg-purple', 'bg-primary'];
              const badgeClasses = ['badge-light-danger', 'badge-light-primary', 'badge-light-info'];

              return (
                <div key={project?.Id || index} className="proj-row">
                  <span className={`proj-dot ${dotClasses[index % dotClasses?.length]}`}></span>
                  <span className="proj-name">{name}</span>
                  <span className={`proj-badge ${badgeClasses[index % badgeClasses?.length]}`}>{tasks} tasks</span>
                </div>
              );
            })}
            {projectDetails?.ProjectList?.length === 0 && (
              <div className="proj-row text-muted">No projects available</div>
            )}
          </div>
          <div className="card-footer-bx">
            <Link to="/Project/List" className="link-sm">
              <i className="fa-solid fa-list-check"></i>View all projects
            </Link>
          </div>
        </div>
      )}
    </>
  )
}

export default MyProjects